// extracted by mini-css-extract-plugin
module.exports = {"footerContainer":"ClientWallet_footerContainer__4Yb2y","savePackageButton":"ClientWallet_savePackageButton__2c-rU"};